import { createSelector } from 'reselect'
import { CODE_LISTS } from 'constants/enums'

const codeList = (list, options) => ({ list, options })

function getValue(value) {
    if (value === 'MESSAGE' || value === 'READ') {
        return 'false'
    } else if (value === 'PRAISE' || value === 'UNREAD') {
        return 'true'
    }

    return value
}

const mapForDropdown = ({ list, options = {} }) => {
  let entryList = list

  if (CODE_LISTS.TITLES.label === options.listType) {
    entryList = [
      {
        textTranslated: '---',
        value: null
      }
    ].concat(entryList)
  }

  return list && Array.isArray(list)
    ? entryList.map(item => ({
        id: item.id,
        label: item.textTranslated,
        value: getValue(item.value)
      }))
    : []
}

export default createSelector(codeList, mapForDropdown)
